module.exports = __webpack_public_path__ + "static/media/back_large.9ad66641.svg";